.banner {
  background: light-dark(
    linear-gradient(90deg, var(--mantine-color-orange-5) 0%, var(--mantine-color-orange-6) 100%),
    linear-gradient(90deg, var(--mantine-color-orange-7) 0%, var(--mantine-color-orange-8) 100%)
  );
  color: white;
  padding: 8px 16px;
  border-bottom: 1px solid light-dark(var(--mantine-color-orange-7), var(--mantine-color-orange-9));
}

/* Compound selector to beat Mantine's default Anchor color without !important */
.banner .exitLink {
  color: white;
  font-size: 0.875rem;
  font-weight: 500;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
}
